import { render, staticRenderFns } from "./my-follow.vue?vue&type=template&id=2330e946&scoped=true"
import script from "./my-follow.vue?vue&type=script&lang=js"
export * from "./my-follow.vue?vue&type=script&lang=js"
import style0 from "./my-follow.vue?vue&type=style&index=0&id=2330e946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330e946",
  null
  
)

export default component.exports